import { memo } from 'react';
import styles from './Card.module.scss'

const SUIT_SYMBOLS = { C: '♣', D: '♦', H: '♥', S: '♠' };
const SUIT_COLORS  = { C: '#1a1a2e', D: '#c0392b', H: '#c0392b', S: '#1a1a2e' };

const Card = (props) => {
    const { suit, rank, active, selected, handleOnCLick, index, displayEmpty, dim } = props;

    const handleClick = () => {
        if (active && handleOnCLick) handleOnCLick(index);
    };

    // Empty slot (green felt)
    if (displayEmpty) return <div className={styles.emptySlot} />;

    // Face-down card
    if (!suit || !rank) return <div className={styles.cardBack} />;

    const color = SUIT_COLORS[suit] || '#1a1a2e';
    const symbol = SUIT_SYMBOLS[suit] || suit;

    return (
        <div
            className={[
                styles.card,
                active   ? styles.active   : '',
                selected ? styles.selected : '',
                dim || (!active && handleOnCLick) ? styles.inactive : ''
            ].join(' ')}
            onClick={handleClick}
            style={{ '--card-color': color }}
        >
            {/* Single top-left index — the only place the card is identified, so it
                stays readable however deeply the card is overlapped in the hand. */}
            <div className={styles.index}>
                <span className={styles.rank}>{rank}</span>
                <span className={styles.suit}>{symbol}</span>
            </div>
            <div className={styles.pip}>{symbol}</div>
        </div>
    );
};

// Memoised: the hand re-renders whenever any round state changes, but a card's
// own props only change when it becomes playable/selected — no reason to
// rebuild thirteen card subtrees each time.
export default memo(Card);
